import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketName } from '../../app/selectors';
import {
  getIngredientsByFilter,
  getIsFetching,
  getIsFetched
} from '../selectors';
import { fetchIngredients } from '../actions';

/**
 * Get data for ingredients.
 *
 * Currently fetches all ingredients the first time around. Filtering is then
 * done in the selector.
 *
 * @param filter
 * @returns {[boolean, *]}
 */
// Consider if useIngredients, useExcludedIngredients and useGlobalIngredients
// should be merged into one hook to make this easier.
const useIngredients = ({
  itemCode = null,
  hasPpi = null,
  isExcluded = false
} = {}) => {
  // console.log(itemCode,hasPpi,isExcluded)
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();
  const isFetchingIngredients = useSelector(getIsFetching);
  // const isFetched = useSelector(getIsFetched);
  const userOrganization = useSelector(getMarketName);
  const isFetching = notStartedFetching ? true : isFetchingIngredients;
  // const isFetching = isFetchingIngredients;
  // console.log("isFetched",isFetched)
  const ingredients = useSelector(
    getIngredientsByFilter({
      //  owningOrganization: userOrganization,
      itemCode,
      hasPpi,
      isExcluded
    })
  );

  const allIngredientsData = useSelector(getIngredientsByFilter({}));
  useEffect(() => {
    // if (!isFetched) {
    // }
    dispatch(fetchIngredients());
    setNotStartedFetching(false);
  }, []);

  return [isFetching, ingredients, allIngredientsData];
};

export default useIngredients;
